
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventId]/sessions/[sessionId]/lecture/[lectureId]",
      function () {
        return require("private-next-pages/events/[eventId]/sessions/[sessionId]/lecture/[lectureId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/[eventId]/sessions/[sessionId]/lecture/[lectureId]"])
      });
    }
  